import { render, staticRenderFns } from "./ProcedimentoFinalizar.vue?vue&type=template&id=4b8c5e02"
import script from "./ProcedimentoFinalizar.vue?vue&type=script&lang=js"
export * from "./ProcedimentoFinalizar.vue?vue&type=script&lang=js"
import style0 from "./ProcedimentoFinalizar.vue?vue&type=style&index=0&id=4b8c5e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports